export default function AccessDenied() {
    return (
        <div>
            <h1>
                Desktop Access Not Allowed
            </h1>

            <p>
                Please use mobile application.
            </p>
        </div>
    );
}